import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { showSessionWarning as showSessionWarning, sessionExpired as sessionExpired } from "./domain/auth/authActions";
import StatusMessage from "./components/presentational/StatusMessage";
import * as Constants from "./constants/Constants";
import * as StatusMessages from "./constants/StatusMessages";
import moment from "moment";
class SecuredContainer extends Component {
    constructor() {
        super(...arguments);
        this._checkTimeout = () => {
            clearTimeout(this._timeoutCheckHandle);
            const now = moment();
            if (!this.props.loggedIn) {
                return;
            }
            if (this.props.sessionWarnTimestamp == null) {
                if (this.props.sessionLength == null) {
                    return;
                }
                const msUntilWarn = this.props.sessionRefreshTimestamp == null ? 0 : moment(this.props.sessionRefreshTimestamp)
                    .add((60 * this.props.sessionLength) - Constants.IDLE_SESSION_WARN_MODAL_DURATION - 30, "seconds")
                    .diff(now);
                if (msUntilWarn <= 0) {
                    this.props.onShowSessionWarning(now);
                }
                else {
                    this._timeoutCheckHandle = setTimeout(this._checkTimeout, Math.min(msUntilWarn, Constants.MAX_TIMEOUT));
                }
            }
            else {
                const msUntilExpire = moment(this.props.sessionWarnTimestamp)
                    .add(Constants.IDLE_SESSION_WARN_MODAL_DURATION, "seconds")
                    .diff(now);
                if (msUntilExpire <= 0) {
                    this.props.onSessionExpired();
                }
                else {
                    this._timeoutCheckHandle = setTimeout(this._checkTimeout, Math.min(msUntilExpire, Constants.MAX_TIMEOUT));
                }
            }
        };
    }
    render() {
        const attrs = {};
        if (this.props.isActiveModal) {
            attrs["aria-hidden"] = true;
        }
        return (<div {...attrs}>
				<div className="content mix-content_centerText">
					<StatusMessage isError={false} isSuccess={this.props.isSuccessContinueSession} isActive={this.props.isSuccessContinueSession ? true : false} customMessage={StatusMessages.AUTH.CONTINUE_SESSION} domain="auth"/>
				</div>
				<Suspense fallback={(<StatusMessage isLoad isActive/>)}>
					{this.props.children}
				</Suspense>
			</div>);
    }
    componentDidMount() {
        this._checkTimeout();
    }
    componentDidUpdate() {
        this._checkTimeout();
    }
    componentWillUnmount() {
        clearTimeout(this._timeoutCheckHandle);
    }
}
export default connect((state) => ({
    loggedIn: state.auth.loggedIn,
    isSuccessContinueSession: state.auth.isSuccessContinueSession,
    sessionLength: state.auth.sessionLength,
    sessionRefreshTimestamp: state.auth.sessionRefreshTimestamp,
    sessionWarnTimestamp: state.auth.sessionWarnTimestamp,
}), {
    onShowSessionWarning: showSessionWarning,
    onSessionExpired: sessionExpired
})(SecuredContainer);



// WEBPACK FOOTER //
// ./src/assets/scripts/SecuredContainer.tsx